import { useMemo, useState } from 'react';
import { Box, Button, Grid } from '@mui/material';
import { PhoenixGrid } from '@shared/components/grid/PhoenixGrid';
import { SectionTitle } from '@shared/components/SectionTitle';
import { ButtonsSection } from '@styles/DealSheet/DealSheetStyles';
import { IDSProps } from '../interfaces';
import { adjustmentsColumns } from '../constants';
import { AdjustmentModal } from './AdjustmentModal';

export const Adjustments = ({ data, refresh }: IDSProps) => {
  const [openAdjustmentModal, setOpenAdjustmentModal] = useState(false);

  const rows = useMemo(
    () => (data?.existingAdjustments ?? []).map((item, index) => ({ ...item, id: index })),
    [data?.existingAdjustments]
  );

  return (
    <Box sx={{ mt: 1 }}>
      <Grid container>
        <Grid
          item
          md={8}
        >
          <SectionTitle
            title="Existing Adjustment"
            variant="h2"
            marginTop={0}
          />
        </Grid>
        <Grid
          item
          md={4}
        >
          <ButtonsSection>
            <Button variant="outlined" onClick={() => setOpenAdjustmentModal(true)}>+ Add</Button>
          </ButtonsSection>
        </Grid>
      </Grid>
      <PhoenixGrid
        autoHeight
        withHeader
        noButton
        columns={adjustmentsColumns}
        rows={rows}
        getRowId={(row) => row.id}
        pageSize={5}
      />

      {openAdjustmentModal &&
        <AdjustmentModal
          dealId={data?.dealId}
          contactId={data?.contactId}
          setOpenAdjustmentModal={setOpenAdjustmentModal}
          refresh={refresh}
        />
      }
    </Box>
  );
};
